import { SpinnerFloatingComponent } from './spinner-floating.component';

export default angular
  .module('sfMobile.components.spinner-floating', [
    'sfMobile.components.spinner',
  ])
  .component('sfSpinnerFloating', SpinnerFloatingComponent).name;
